import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionCardProps } from '..';
import { LateralBar } from '../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useSubscriptionDetailContext } from '../../../contexts/SubscriptionDetail';
import { SubscriptionInfo } from '../components/SubscriptionInfo';
import { SubscriptionMainInfo } from '../components/SubscriptionMainInfo';
import { SubscriptionTimeLimit } from '../components/SubscriptionTimeLimit';

export const SubscriptionCardTablet: React.FC<SubscriptionCardProps> = ({
  openDetails,
  subscription,
}) => {
  const { setModalOpen, setSubscriptionSelected } = useSubscriptionDetailContext();

  const handleOpenItemDetailsModal = () => {
    setModalOpen(true);
    setSubscriptionSelected(subscription);
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack space="stack.xxxs">
          <HStack justifyContent="space-between" alignItems="center">
            <Stack w="1/3">
              <SubscriptionMainInfo
                description={`ISIN: ${subscription.baseIsinCode}`}
                title={subscription.productDisplay}
                onDetailsPress={handleOpenItemDetailsModal}
                hasLeftovers={subscription.hasLeftovers}
              />
            </Stack>
            <Stack w="1/5" alignItems="center">
              <SubscriptionInfo label="Data Execução" value={subscription.executionDateFormatted} />
            </Stack>
            <Stack w="1/5" alignItems="center">
              <SubscriptionInfo label="Data limite" value={subscription.limitDateFormatted} />
            </Stack>
            <Stack w="1/5" alignItems="end">
              <SubscriptionInfo
                label="Data liquidação"
                value={subscription.settlementDateFormatted}
              />
            </Stack>
          </HStack>
          <HStack justifyContent="space-between" alignItems="center">
            <Stack w="1/3">
              <SubscriptionTimeLimit
                daysSinceDeadline={subscription.daysSinceDeadline}
                daysToDeadline={subscription.daysToSettlement}
                type={subscription.timeLimitType}
              />
            </Stack>
            <Stack w="1/5" alignItems="center">
              <SubscriptionInfo
                label="Clientes aptos"
                value={`${subscription.customersEligible}`}
              />
            </Stack>
            <Stack w="1/5" alignItems="center">
              <SubscriptionInfo label="Preço unitário" value={subscription.unitaryPriceFormatted} />
            </Stack>
            <Stack w="1/5" alignItems="end">
              <UI.Button
                variant="textLink"
                isDisabled={false}
                _text={{
                  color: 'brand.tertiary.principal',
                  fontFamily: Typography['fontfamily.base.semibold'],
                }}
                onPress={openDetails}>
                DETALHES
              </UI.Button>
            </Stack>
          </HStack>
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
